module.exports = __webpack_public_path__ + "img/Frame-2.17e01d15.svg";